import { BaseValidator } from './baseValidator';
import { ValidatorResult } from './validatorRule.constants';
import ValidationErrors from '../fields/validationErrors';

export class AddressLineFieldValidator extends BaseValidator {
    public EUAddressLineLengthRule(value: string): ValidatorResult {
        const MAX_LENGTH = 255;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'EUAddressLineLengthRule',
            };
        }
        return null;
    }

    public JPAddressLineLengthRule(value: string) {
        const MAX_LENGTH = 85;
        if (value.length > MAX_LENGTH) {
            return {
                value: value,
                message: ValidationErrors.fieldTooLongMessageProps(MAX_LENGTH),
                rule: 'EUAddressLineLengthRule',
            };
        }
        return null;
    }
}
